import { ChameleonVersionMixin as VersionMixin } from '@getgo/chameleon-toolkit';
export const ChameleonVersionMixin = VersionMixin('@getgo/chameleon-typography 2.1.1');
